import { createReducer, createAction } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  categories: [],
};

export const get = createAction('CATEGORY_GET');

export default createReducer(INITIAL_STATE, {
  [get.type]: (state, action) => ({
    ...state,
    categories: action.payload.categories,
  }),
});
